import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import './styles/globals.css';

import Navbar       from './components/Navbar';
import Footer       from './components/Footer';
import ParticleField from './components/ParticleField';

import HomePage    from './pages/HomePage';
import AboutPage   from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import SupportPage  from './pages/SupportPage';
import ContactPage  from './pages/ContactPage';

import useScrollReveal from './hooks/useScrollReveal';

/** Scrolls to top on every route change */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout() {
  useScrollReveal(); // re-run observer after every render / route change

  return (
    <>
      <ParticleField />
      <Navbar />
      <main style={{ position: 'relative', zIndex: 1 }}>
        <Routes>
          <Route path="/"        element={<HomePage    />} />
          <Route path="/about"   element={<AboutPage   />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* 404 fallback */}
          <Route path="*" element={
            <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1rem', paddingTop: 68 }}>
              <h1 style={{ fontFamily: 'var(--font-d)', fontSize: 80, fontWeight: 900, color: 'var(--coral)' }}>404</h1>
              <p style={{ color: 'var(--muted)' }}>Page not found.</p>
              <a href="/" style={{ color: 'var(--coral)', fontFamily: 'var(--font-m)', fontSize: 13, textDecoration: 'none' }}>← Back to Home</a>
            </div>
          } />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout />
    </BrowserRouter>
  );
}
